import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import ActionsRow from '@lib/components/ActionsRow/ActionsRow';
import styles from '@lib/assets/styles/Form.module.scss';

function TaskEditFormActions() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <ActionsRow
      className={styles.formActions}
      actions={[
        <Button
          onClick={() => navigate(-1)}
          buttonType={ButtonTypes.secondaryOutlined}
          buttonText={t('cancel')}
          data-test-id="task-form__cancel-button"
          leftIcon="close"
          fullWidth
        />,
        <Button
          buttonType={ButtonTypes.primaryFilled}
          buttonText={t('save-changes')}
          data-test-id="task-form__save-button"
          leftIcon="check"
          type="submit"
          fullWidth
        />,
      ]}
    />
  );
}

export default TaskEditFormActions;
